import { create } from 'zustand';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Shared cache for GET /api/user-preferences (SMTP config + WhatsApp number).
 *
 * Same contract as docPrefsStore: fetch dedupe + optimistic update + reset.
 * NOTE: password is returned masked by the server ("••••••••"); we never
 * hold the plaintext in the client.
 */
export const useUserPrefsStore = create((set, get) => ({
  data: null,
  loading: false,
  error: null,
  _inflight: null,

  fetch: async (opts = {}) => {
    const { force = false } = opts;
    const state = get();
    if (!force && state.data) return state.data;
    if (state._inflight) return state._inflight;
    // Same pre-auth gate as docPrefsStore — bail when no token yet so
    // we don't fire noisy 403s on first paint before AuthProvider's
    // useEffect attaches the Authorization header.
    if (typeof window !== 'undefined' && !window.localStorage.getItem('token')) {
      return null;
    }

    const p = (async () => {
      set({ loading: true, error: null });
      try {
        const res = await axios.get(`${API}/user-preferences`);
        set({ data: res.data, loading: false, _inflight: null });
        return res.data;
      } catch (err) {
        set({ loading: false, error: err, _inflight: null });
        throw err;
      }
    })();

    set({ _inflight: p });
    return p;
  },

  update: async (payload) => {
    const prev = get().data;
    try {
      const res = await axios.put(`${API}/user-preferences`, payload);
      set({ data: res.data });
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err };
    }
  },

  reset: () => set({ data: null, loading: false, error: null, _inflight: null }),
}));
